import Button from "../../../../../common/components/button";
import TableName from "../../../../components/common/tableName";
import Input from "../../../../components/common/input";
import SelectBox from "../../../../components/common/selectBox";
import { ReactComponent as UploadImage } from "../../../../assets/icons/uploadImage.svg";
import { useGetGoodsInfo } from "../../../../../common/hooks/console/management/goods/useGetGoodsInfo";
import React, { useEffect, useState } from "react";
import { useGetGoodsCategory } from "../../../../../common/hooks/console/management/goods/useGetGoodsCategory";
import useToastStore from "../../../../store/useToastStore";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/closeWhiteIcon.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plusIcon.svg";
import { api_uri } from "../../../../../common/hooks/utils/enum";
import { usePutGoods } from "../../../../../common/hooks/console/management/goods/usePutGoods";
import Toggle from "../../../../components/common/toggle";
import { ReactComponent as CloseBlackIcon } from "../../../../assets/icons/closeIcon.svg";
import { ReactComponent as UploadOnImage } from "../../../../assets/icons/uploadOnImage.svg";
import { useAuthStore } from "../../../../store/useAuthStore";
import { useSystemPopStore } from "../../../../store/useSystemPopStore";
import { useGetGoodsCode } from "../../../../../common/hooks/console/management/goods/useGetGoodsCode";
import GoodsHistory from "./GoodsHistory";

const ModifyGoods = ({ productIdx, onDelete }: { productIdx: number; onDelete: (idx: number) => void }) => {
    const { addToast } = useToastStore();
    const { showPop } = useSystemPopStore();
    const level = useAuthStore(state => state.m_level);

    const { data: productInfo } = useGetGoodsInfo(productIdx);
    const { data: categoryData } = useGetGoodsCategory();
    const { data: codeData } = useGetGoodsCode();

    const { mutate } = usePutGoods(() => {
        addToast({ type: "success", message: "상품 정보가 수정되었습니다." });
    });

    const handleDelete = () => {
        onDelete(productIdx);
    };

    const [status, setStatus] = useState<boolean>(false);
    const [selectedCategory, setSelectedCategory] = useState<string>("");
    const [selectedCode, setSelectedCode] = useState<string>("");
    const [productName, setProductName] = useState<string>("");
    const [productAmount, setProductAmount] = useState<number>(0);
    const [productContent, setProductContent] = useState<string>("");
    const [productMemo, setProductMemo] = useState<string>("");
    const [productImages, setProductImages] = useState<(File | string)[]>([]);
    const [noticeImages, setNoticeImages] = useState<(File | string)[]>([]);
    const [delFileIdx, setDelFileIdx] = useState<number[]>([]);
    const [previewImage, setPreviewImage] = useState<string | null>(null);
    const [productUploadPop, setProductUploadPop] = useState(false);
    const [noticeUploadPop, setNoticeUploadPop] = useState(false);
    const [tempProductImages, setTempProductImages] = useState<(File | string)[]>([]);
    const [tempNoticeImages, setTempNoticeImages] = useState<(File | string)[]>([]);
    const [initialData, setInitialData] = useState<any>(null);

    const categoryOptions = categoryData
        ? categoryData.map(cat => ({
              value: cat.product_category_idx.toString(),
              label: cat.category_name,
          }))
        : [];

    const selectedCategoryLabel = categoryOptions.find(option => option.value === selectedCategory)?.label;
    const isMainCategory = selectedCategoryLabel === "대분료";

    const codeOptions = codeData
        ? codeData.map(code => ({
              value: code.product_code_idx.toString(),
              label: code.product_code_name + " / " + code.product_code,
          }))
        : [];

    const openImageUploadPop = (type: "product" | "notice") => {
        if (type === "product") {
            setProductUploadPop(true);
            setNoticeUploadPop(false);
            setTempProductImages([...productImages]);
        } else {
            setNoticeUploadPop(true);
            setProductUploadPop(false);
            setTempNoticeImages([...noticeImages]);
        }
    };

    const handleCancel = () => {
        if (initialData) {
            setStatus(initialData.status);
            setSelectedCategory(initialData.selectedCategory);
            setSelectedCode(initialData.selectedCode);
            setProductName(initialData.productName);
            setProductAmount(initialData.productAmount);
            setProductContent(initialData.productContent);
            setProductMemo(initialData.productMemo);
            setProductImages(initialData.productImages);
            setNoticeImages(initialData.noticeImages);
            setDelFileIdx([]);
        }
    };

    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>, type: "product" | "notice") => {
        if (e.target.files) {
            const files = Array.from(e.target.files);

            if (type === "product") {
                const newFiles = [...tempProductImages, ...files];
                if (newFiles.length > 4) {
                    showPop({
                        title: "이미지는 최대 4장까지 <br /> 등록할 수 있습니다.",
                        type: "negative",
                        onRightClick: () => {},
                    });
                    return;
                }
                setTempProductImages(newFiles);
            } else {
                const newFiles = [...tempNoticeImages, ...files];
                if (newFiles.length > 4) {
                    showPop({
                        title: "이미지는 최대 4장까지 <br /> 등록할 수 있습니다.",
                        type: "negative",
                        onRightClick: () => {},
                    });
                    return;
                }
                setTempNoticeImages(newFiles);
            }
        }
    };
    const handlePreviewImage = (image: string | File) => {
        const imageUrl = typeof image === "string" ? image : URL.createObjectURL(image);
        setPreviewImage(imageUrl);
    };
    const handleRemoveImage = (index: number, type: "product" | "notice", isPopup: boolean = false) => {
        const targetImages = isPopup
            ? type === "product"
                ? tempProductImages
                : tempNoticeImages
            : type === "product"
              ? productImages
              : noticeImages;
        const removedImage = targetImages[index];

        if (typeof removedImage === "string") {
            const fileList = type === "product" ? productInfo?.product_image : productInfo?.notice_image;
            const fileId = fileList?.find(img => `${api_uri}/${img.file_name}` === removedImage)?.file_idx;
            if (fileId) {
                setDelFileIdx(prev => [...prev, fileId]);
            }
        }

        if (isPopup) {
            if (type === "product") {
                setTempProductImages(prev => prev.filter((_, i) => i !== index));
            } else {
                setTempNoticeImages(prev => prev.filter((_, i) => i !== index));
            }
        } else {
            if (type === "product") {
                setProductImages(prev => prev.filter((_, i) => i !== index));
            } else {
                setNoticeImages(prev => prev.filter((_, i) => i !== index));
            }
        }
    };

    const handleConfirmImages = (type: "product" | "notice") => {
        if (type === "product") {
            setProductImages(tempProductImages);
            setProductUploadPop(false);
        } else {
            setNoticeImages(tempNoticeImages);
            setNoticeUploadPop(false);
        }
    };

    const handleSave = () => {
        mutate({
            product_idx: productIdx,
            product_category_idx: Number(selectedCategory),
            product_code_idx: Number(selectedCode),
            product_name: productName,
            product_amount: productAmount,
            product_content: productContent,
            product_memo: productMemo,
            status,
            del_file_idx: delFileIdx,
            product_image: productImages.filter(img => img instanceof File) as File[],
            notice_image: noticeImages.filter(img => img instanceof File) as File[],
        });
        setDelFileIdx([]);
    };

    const handleDrop = (e: React.DragEvent<HTMLLabelElement>, type: "product" | "notice") => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);

        if (type === "product") {
            const newFiles = [...tempProductImages, ...files];
            if (newFiles.length > 4) {
                showPop({
                    title: "이미지는 최대 4장까지 <br /> 등록할 수 있습니다.",
                    type: "negative",
                    onRightClick: () => {},
                });
                return;
            }
            setTempProductImages(newFiles);
        } else {
            const newFiles = [...tempNoticeImages, ...files];
            if (newFiles.length > 4) {
                showPop({
                    title: "이미지는 최대 4장까지 <br /> 등록할 수 있습니다.",
                    type: "negative",
                    onRightClick: () => {},
                });
                return;
            }
            setTempNoticeImages(newFiles);
        }
    };
    const handleCloseImageUploadPop = (type: "product" | "notice") => {
        if (type === "product") {
            setTempProductImages(prev => {
                const validImages = productImages.filter(image => image instanceof File || typeof image === "string");
                return [...validImages];
            });
            setProductUploadPop(false);
        } else {
            setTempNoticeImages(prev => {
                const validImages = noticeImages.filter(image => image instanceof File || typeof image === "string");
                return [...validImages];
            });
            setNoticeUploadPop(false);
        }
    };

    useEffect(() => {
        if (productInfo) {
            const initial = {
                status: productInfo.status,
                selectedCode: productInfo.product_code_idx?.toString(),
                selectedCategory: productInfo.product_category.product_category_idx.toString(),
                productName: productInfo.product_name,
                productAmount: productInfo.product_amount,
                productContent: productInfo.product_content,
                productMemo: productInfo.product_memo,
                productImages: productInfo.product_image?.map(img => `${api_uri}/${img.file_name}`),
                noticeImages: productInfo.notice_image?.map(img => `${api_uri}/${img.file_name}`),
            };

            setStatus(initial.status);
            setSelectedCategory(initial.selectedCategory);
            setSelectedCode(initial.selectedCode);
            setProductName(initial.productName);
            setProductAmount(initial.productAmount);
            setProductContent(initial.productContent);
            setProductMemo(initial.productMemo);
            setProductImages(initial.productImages);
            setNoticeImages(initial.noticeImages);
            setInitialData(initial);
        }
    }, [productInfo]);

    useEffect(() => {
        const handlePaste = (e: ClipboardEvent) => {
            const items = e.clipboardData?.items;
            if (items) {
                const images: File[] = [];
                for (let i = 0; i < items.length; i++) {
                    if (items[i].kind === "file") {
                        const file = items[i].getAsFile();
                        if (file && file.type.startsWith("image/")) {
                            images.push(file);
                        }
                    }
                }
                if (images.length > 0) {
                    if (productUploadPop) {
                        const newFiles = [...tempProductImages, ...images];
                        if (newFiles.length > 4) {
                            showPop({
                                title: "이미지는 최대 4장까지 <br /> 등록할 수 있습니다.",
                                type: "negative",
                                onRightClick: () => {},
                            });
                            setTempProductImages(newFiles.slice(0, 4));
                            return;
                        }
                        setTempProductImages(newFiles.slice(0, 4));
                    } else if (noticeUploadPop) {
                        const newFiles = [...tempNoticeImages, ...images];
                        if (newFiles.length > 4) {
                            showPop({
                                title: "이미지는 최대 4장까지 <br /> 등록할 수 있습니다.",
                                type: "negative",
                                onRightClick: () => {},
                            });
                            setTempNoticeImages(newFiles.slice(0, 4));
                            return;
                        }
                        setTempNoticeImages(newFiles.slice(0, 4));
                    }
                }
            }
        };

        document.addEventListener("paste", handlePaste);
        return () => document.removeEventListener("paste", handlePaste);
    }, [productUploadPop, noticeUploadPop, tempProductImages, tempNoticeImages]);

    return (
        <div className="bg-gray6 p-4 h-full">
            <div className="bg-white shadow-custom rounded-xl px-3 py-5 flex flex-col gap-5">
                <div className="flex flex-col">
                    <div className="flex items-center justify-between gap-3">
                        <p className="text-xl font-bold truncate">
                            [{productInfo?.product_category.category_name}] {productInfo?.product_name}
                        </p>
                        {/*
                        // 이미 지워진 상품은 또 지울 수 없다. 복구는 목록의 '복구' 버튼에서 한다.
                        */}
                        {productInfo?.is_delete ? (
                            <p className="shrink-0 rounded-lg bg-error px-2 py-1 text-sm text-white">삭제된 상품</p>
                        ) : (
                            level !== 7 &&
                            level !== 8 && (
                                <Button status="error" size="S" className="min-w-[41px]" onClick={handleDelete}>
                                    삭제
                                </Button>
                            )
                        )}
                    </div>
                    <p className="text-sm text-gray2">{productInfo?.reg_date} 등록</p>
                    <div className="mt-2">
                        <GoodsHistory productIdx={productIdx} />
                    </div>
                </div>

                <div className="flex flex-col gap-3">
                    <div className="border-t-2 border-gray2">
                        <div className="flex items-center border-b border-gray4">
                            <TableName className="h-12" required>
                                노출여부
                            </TableName>
                            <Toggle
                                className="pl-2"
                                onLabel="노출"
                                offLabel="숨김"
                                isOn={status}
                                onToggle={() => {
                                    setStatus(!status);
                                }}
                                disabled={level === 7}
                            />
                        </div>
                        <div className="flex items-center border-b border-gray4">
                            <TableName className="h-12" required>
                                카테고리
                            </TableName>
                            <SelectBox
                                height="max-h-96"
                                className="w-full px-2"
                                placeholder="카테고리 선택"
                                options={categoryOptions}
                                value={selectedCategory}
                                onChange={value => {
                                    setSelectedCategory(value);

                                    const selectedLabel = categoryOptions.find(option => option.value === value)?.label;
                                    if (selectedLabel === "대분류") {
                                        setSelectedCode("");
                                    }
                                }}
                                full
                                disabled={level === 7}
                            />
                        </div>
                        {!isMainCategory && (
                            <div className="flex items-center border-b border-gray4">
                                <TableName className="h-12 whitespace-nowrap">베스트플라워</TableName>
                                <SelectBox
                                    height="max-h-96"
                                    className="w-full px-2"
                                    placeholder="선택"
                                    options={codeOptions}
                                    value={selectedCode}
                                    onChange={value => {
                                        setSelectedCode(value);
                                    }}
                                    full
                                    disabled={level === 7}
                                />
                            </div>
                        )}

                        <div className="flex items-center border-b border-gray4">
                            <TableName className="h-12" required>
                                상품명
                            </TableName>
                            <Input
                                maxLength={30}
                                placeholder="30자"
                                status={level === 7 ? "view" : undefined}
                                className="px-2 w-full"
                                value={productName ?? ""}
                                onChange={e => setProductName(e.target.value)}
                            />
                        </div>
                        <div className="flex items-center w-1/2">
                            <TableName className="h-12" required>
                                가격
                            </TableName>
                            <Input
                                status={level === 7 ? "view" : undefined}
                                price
                                className="px-2 w-full"
                                value={productAmount.toLocaleString() ?? ""}
                                onChange={e => setProductAmount(Number(e.target.value.replace(/[^0-9]/g, "")))}
                            />
                        </div>
                        <div className="flex border-y border-gray4 items-stretch">
                            <TableName>
                                상품이미지
                                <br />
                                (최대 4장)
                            </TableName>
                            <div className="flex gap-2 flex-wrap p-2 w-full">
                                {level !== 7 && productImages.length >= 1 && (
                                    <div
                                        className={`${productUploadPop ? "border-primary2 text-primary2" : " border-gray5 border-dashed text-grayicon"} ${level !== 7 && "cursor-pointer"} w-[60px] flex flex-col items-center border rounded-xl p-2`}
                                        onClick={() => openImageUploadPop("product")}
                                    >
                                        <PlusIcon />
                                        <p className="text-sm">추가</p>
                                    </div>
                                )}
                                {productImages.map((image, index) => (
                                    <div key={index} className="relative w-[60px] h-[60px] border rounded-xl overflow-hidden">
                                        <img
                                            onClick={() => handlePreviewImage(image)}
                                            src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                            className="w-full h-full object-contain cursor-pointer"
                                            alt="image"
                                        />
                                        {level !== 7 && (
                                            <button
                                                className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                onClick={() => handleRemoveImage(index, "product", false)}
                                            >
                                                <CloseIcon />
                                            </button>
                                        )}
                                    </div>
                                ))}

                                {productImages.length < 1 && (
                                    <div
                                        className={`${productUploadPop ? "bg-primary4 border-primary2 text-primary2" : "border-gray5 border-dashed text-grayicon"} ${level !== 7 && "cursor-pointer"} w-full flex flex-col items-center border rounded-xl p-2`}
                                        onClick={() => {
                                            level !== 7 && openImageUploadPop("product");
                                        }}
                                    >
                                        {productUploadPop ? <UploadOnImage /> : <UploadImage />}
                                        <p className="text-sm">이미지 업로드</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* 이미지 업로드 팝업 */}
                        {productUploadPop && (
                            <div className="flex flex-col z-50 absolute w-[400px] bg-white rounded-2xl shadow-custom translate-x-[107px] -translate-y-1">
                                <div className="flex w-full  items-center px-5 justify-between py-5 ">
                                    <p className="text-primary1 text-2xl font-bold">이미지 업로드</p>
                                    <p className="text-sm">최대 4장까지 업로드 가능합니다.</p>
                                    <CloseBlackIcon className="cursor-pointer" onClick={() => handleCloseImageUploadPop("product")} />
                                </div>
                                <div className="px-6 pb-5 flex flex-col gap-2">
                                    <label
                                        onDrop={e => handleDrop(e, "product")}
                                        onDragOver={e => e.preventDefault()}
                                        className="flex h-[160px] justify-center cursor-pointer flex-col items-center border border-gray5 border-dashed rounded-xl"
                                    >
                                        <UploadImage className="w-[72px] h-[72px] mb-2" />
                                        <p className="text-gray2 text-sm">이미지 업로드</p>
                                        <p className="text-gray3 text-sm">(이미지를 드래그하거나 복사, 붙여넣기하여 등록)</p>
                                        <input
                                            type="file"
                                            className="hidden"
                                            multiple
                                            onChange={event => handleImageUpload(event, "product")}
                                        />
                                    </label>
                                    <div className="flex gap-1">
                                        {tempProductImages.map((image, index) => (
                                            <div key={index} className="relative w-[60px] h-[60px] border rounded-xl overflow-hidden">
                                                <img
                                                    src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                                    className="w-full h-full object-contain"
                                                    alt="image"
                                                />
                                                <button
                                                    className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                    onClick={() => handleRemoveImage(index, "product", true)}
                                                >
                                                    <CloseIcon />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    <Button size="L" status="regist" className="w-full" onClick={() => handleConfirmImages("product")}>
                                        이미지 등록
                                    </Button>
                                </div>
                            </div>
                        )}
                        <div className="flex border-b border-gray4 items-stretch">
                            <TableName>
                                구매시
                                <br /> 유의사항
                            </TableName>
                            <div className="flex gap-2 flex-wrap p-2 w-full">
                                {level !== 7 && noticeImages.length >= 1 && (
                                    <div
                                        className={`${noticeUploadPop ? "border-primary2 text-primary2" : " border-gray5 border-dashed text-grayicon"} ${level !== 7 && "cursor-pointer"} w-[60px] flex flex-col items-center border rounded-xl p-2`}
                                        onClick={() => openImageUploadPop("notice")}
                                    >
                                        <PlusIcon />
                                        <p className="text-sm">추가</p>
                                    </div>
                                )}
                                {noticeImages.map((image, index) => (
                                    <div key={index} className="relative w-[60px] h-[60px] border rounded-xl overflow-hidden">
                                        <img
                                            onClick={() => handlePreviewImage(image)}
                                            src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                            className="w-full h-full object-contain cursor-pointer"
                                        />
                                        {level !== 7 && (
                                            <button
                                                className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                onClick={() => handleRemoveImage(index, "notice", false)}
                                            >
                                                <CloseIcon />
                                            </button>
                                        )}
                                    </div>
                                ))}

                                {noticeImages.length < 1 && (
                                    <div
                                        className={`${noticeUploadPop ? "bg-primary4 border-primary2 text-primary2" : "border-gray5 border-dashed text-grayicon"} ${level !== 7 && "cursor-pointer"} w-full flex flex-col items-center border rounded-xl p-2`}
                                        onClick={() => {
                                            {
                                                level !== 7 && openImageUploadPop("notice");
                                            }
                                        }}
                                    >
                                        {noticeUploadPop ? <UploadOnImage /> : <UploadImage />}
                                        <p className="text-sm">이미지 업로드</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* 이미지 업로드 팝업 */}
                        {noticeUploadPop && (
                            <div className="flex flex-col z-50 absolute w-[400px] bg-white rounded-2xl shadow-custom translate-x-[107px] -translate-y-1">
                                <div className="flex w-full  items-center px-5 justify-between py-5 ">
                                    <p className="text-primary1 text-2xl font-bold">이미지 업로드</p>
                                    <p className="text-sm">최대 4장까지 업로드 가능합니다.</p>
                                    <CloseBlackIcon className="cursor-pointer" onClick={() => handleCloseImageUploadPop("notice")} />
                                </div>
                                <div className="px-6 pb-5 flex flex-col gap-2">
                                    <label
                                        onDrop={e => handleDrop(e, "notice")}
                                        onDragOver={e => e.preventDefault()}
                                        className="flex h-[160px] justify-center cursor-pointer flex-col items-center border border-gray5 border-dashed rounded-xl"
                                    >
                                        <UploadImage className="w-[72px] h-[72px] mb-2" />
                                        <p className="text-gray2 text-sm">이미지 업로드</p>
                                        <p className="text-gray3 text-sm">(이미지를 드래그하거나 복사, 붙여넣기하여 등록)</p>
                                        <input
                                            type="file"
                                            className="hidden"
                                            multiple
                                            onChange={event => handleImageUpload(event, "notice")}
                                        />
                                    </label>
                                    <div className="flex gap-1">
                                        {tempNoticeImages.map((image, index) => (
                                            <div key={index} className="relative w-[60px] h-[60px] border rounded-xl overflow-hidden">
                                                <img
                                                    src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                                    className="w-full h-full object-contain"
                                                />
                                                <button
                                                    className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                    onClick={() => handleRemoveImage(index, "notice", true)}
                                                >
                                                    <CloseIcon />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    <Button size="L" status="regist" className="w-full" onClick={() => handleConfirmImages("notice")}>
                                        이미지 등록
                                    </Button>
                                </div>
                            </div>
                        )}
                        <div className="flex border-b border-gray4 h-[120px] relative">
                            <TableName>상품소개</TableName>
                            <textarea
                                maxLength={1000}
                                disabled={level === 7}
                                className="border m-2 rounded-lg w-full resize-none outline-0 py-1.5 px-3 text-sm"
                                value={productContent ?? ""}
                                onChange={e => setProductContent(e.target.value)}
                            />
                            <div className="absolute bottom-3 right-4 text-xs text-gray2">{productContent?.length || 0}/1000</div>
                        </div>

                        <div className="flex items-center border-b border-gray4">
                            <TableName className="h-12">메모</TableName>
                            <Input
                                maxLength={100}
                                status={level === 7 ? "view" : undefined}
                                className="px-2 w-full"
                                value={productMemo ?? ""}
                                onChange={e => setProductMemo(e.target.value)}
                            />
                        </div>
                    </div>
                    {level !== 7 && (
                        <div className="flex w-full gap-2">
                            <Button size="L" className="w-full" onClick={handleCancel}>
                                취소
                            </Button>
                            <Button onClick={handleSave} size="L" status="regist" className="w-full">
                                저장
                            </Button>
                        </div>
                    )}
                    {previewImage && (
                        <div
                            className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
                            onClick={() => setPreviewImage(null)}
                        >
                            <div className="w-[920px] bg-white rounded-2xl shadow-custom">
                                <div className="flex items-center justify-between px-6 py-5">
                                    <p className="text-2xl font-bold">이미지 크게 보기</p>
                                    <CloseBlackIcon className="cursor-pointer" onClick={() => setPreviewImage(null)} />
                                </div>
                                <div className="flex p-5  items-center justify-center ">
                                    <img src={previewImage} alt="preview" className="object-contain max-h-[500px]" />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ModifyGoods;
